import { useRouter } from 'vue-router'

/**
 * Composable to eliminate duplicated save→route pattern in new item views.
 *
 * @param {Object} dv - The reactive object returned by useNewView()
 * @param {Object} options
 * @param {Function} options.getRoute - (record) => route object for router.push after save
 * @param {Function} [options.preSave] - async callback run before createRecord()
 * @param {Function} [options.postSave] - async callback run after createRecord(record)
 */
export function useNewItemSave(dv, { getRoute, preSave, postSave }) {
  const router = useRouter()

  async function handleSave() {
    try {
      if (preSave) await preSave()
      const record = await dv.createRecord()
      if (postSave) await postSave(record)
      router.replace(getRoute(record))
    } catch {
      // Error already notified by useNewView
    }
  }

  return { handleSave }
}
